import gql from 'graphql-tag';

interface PageInput {
    pageNumber: number;
    quantityRecords: number;
}

export interface MessageTemplateInput {
    conversationId?: number;
    callListId?: number;
    page?: PageInput;
}

export default gql(`
    query($criteria: MessageTemplateInput) {
        messageTemplates(criteria: $criteria) {
            templates {
                id,
                name,
                dealerId,
                callListId,
                language,
                priority,
                metadata {
                    summary
                },
                template {
                    message,
                    fields {
                        name,
                        specialValidations,
                        defaultValue
                    }
                }
            }
            pageInfo {
                size
                totalElements
                totalPages
                current: number
            }
        }
    }
`);



// WEBPACK FOOTER //
// ./src/sections/MessageTemplatesList/MessageTemplatesQuery.ts